(function ($) {
    var didScroll;
    var lastScrollTop = 0;
    var minScroll = 5;

    $(window).scroll(function (event) {

        didScroll = true;

    });

    setInterval(function () {

        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }

    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();
        var navbarHeight = $('#site-header').outerHeight();

        // Make sure they scroll more than minScroll
        if (Math.abs(lastScrollTop - st) <= minScroll)
            return;

        if (st > lastScrollTop && st > navbarHeight) {

            // Scroll Down
            setTimeout(function () {
                $('#site-header').css('top', -navbarHeight);
            }, 200);

        } else {

            // Scroll Up
            if (st < lastScrollTop) {
                $('#site-header').css('top', '0');
                $('html').addClass('scrolled');
            }
            if (st < navbarHeight) {
                $('#site-header').css('top', '0');
                $('html').removeClass('scrolled');
            }

        }

        lastScrollTop = st;

    }

})(jQuery);
